import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { Text, TextTypography } from '../Text';
import { Button, ButtonPriority } from '../Button';
import { CustomDialog } from '..';
import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { IconButton } from '../IconButton';

const CustomDialogVisual = () => (
  <CustomDialog isOpen>
    <div
      style={{
        backgroundColor: 'white',
        position: 'absolute',
        top: '0',
        left: '0',
        padding: '20px',
      }}
    >
      <div>
        <IconButton icon={<Close />} />
      </div>
      <div>
        <div className="content" style={{ textAlign: 'center' }}>
          <Text typography={TextTypography.largeTitle}>Are You Sure?</Text>
          <div
            className="text-container"
            style={{ marginTop: '24px', marginBottom: '36px' }}
          >
            <Text typography={TextTypography.listText} tagName="div">
              <div>Do you really want to delete the selected files?</div>
              <div>Once removed, cannot be undone.</div>
            </Text>
          </div>
          <Button
            upgrade
            priority={ButtonPriority.secondary}
            style={{ marginLeft: '10px' }}
          >
            SECONDARY
          </Button>
          <Button
            upgrade
            style={{ marginLeft: '10px' }}
            priority={ButtonPriority.primary}
          >
            PRIMARY
          </Button>
        </div>
      </div>
    </div>
  </CustomDialog>
);

visualize('CustomDialog', () => {
  story('simple', () => {
    snap(`Custom Dialog with some content`, <CustomDialogVisual />);
  });

  story('wst variables', () => {
    const WstTest = ({
      variables,
    }: {
      variables: Record<`--wst-${string}`, string>;
    }) => {
      return (
        <div style={{ ...variables }}>
          <CustomDialog isOpen>
            <div style={{ position: 'absolute', top: 0, left: 0 }}>
              Custom children for a custom dialog
            </div>
          </CustomDialog>
        </div>
      );
    };

    snap(
      'system line 1',
      <WstTest variables={{ '--wst-system-line-1-color-rgb': '0,255,0' }} />,
    );
  });
});
